<template>
	<div class="max-content">
		<div class="meeting-details_602">
			<div class="content">
				<top-image :images="images"></top-image>
				<div class="banner-show">
					<div class="cover">
						<van-swipe :autoplay="3000" indicator-color="white" :show-indicators="false">
							<van-swipe-item v-for="(item, key, index) in swiperImg" :key="index"
								@click="clickSwiperImg(item)">
								<img :src="item.image" alt="">
							</van-swipe-item>
						</van-swipe>
						<p v-if="show_views" class="views"><van-icon name="eye-o" style="margin-right:5px" />{{ views }}
						</p>
					</div>
				</div>

				<!-- 搜索框显示判断 -->
				<div class="search" v-if="search_writer_show == 1">
					<div class="head">
						<van-search shape="round" v-model="name" placeholder="请输入专家姓名/医院名称" @search="searchExpert" />
					</div>
				</div>
				<div class="bg" v-if="meetingButton.length != 0">
					<div class="relation602">
						<van-row>
							<van-col span="16">
								<van-row>
									<a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[0])">
										<img src="./images/1.png" alt="">
									</a>
								</van-row>
								<van-row>
									<a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[2])">
										<img src="./images/12.png" alt="">
									</a>
								</van-row>
							</van-col>
							<van-col span="8">
								<a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[1])">
									<img src="./images/2.png" alt="">
								</a>
							</van-col>
						</van-row>
						<van-row>
							<van-col span="16">

								<van-row>
									<van-col span="12">
										<a href="Javascript:void(0)" title="picname"
											@click="skipLink(meetingButton[4])">
											<img src="./images/111.png" alt="">
										</a>
									</van-col>
									<van-col span="12">
										<a href="Javascript:void(0)" title="picname"
											@click="skipLink(meetingButton[3])">
											<img src="./images/6.png" alt="">
										</a>
									</van-col>
								</van-row>
							</van-col>
							<van-col span="8">
								<a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[5])">
									<img src="./images/7.png" alt="">
								</a>
							</van-col>
						</van-row>
						<van-row>
							<van-col span="8">
								<a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[6])">
									<img src="./images/8.png" alt="">
								</a>
							</van-col>
							<van-col span="16">
								<van-row>
									<a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[7])">
										<img src="./images/13.png" alt="">
									</a>
								</van-row>
								<van-row>
									<van-col span="12">
										<a href="Javascript:void(0)" title="picname"
											@click="skipLink(meetingButton[8])">
											<img src="./images/10.png" alt="">
										</a>
									</van-col>
									<van-col span="12">
										<a href="Javascript:void(0)" title="picname"
											@click="skipLink(meetingButton[9])">
											<img src="./images/11.png" alt="">
										</a>
									</van-col>
								</van-row>
							</van-col>

						</van-row>
					</div>
					<bottom :name="meeting_name" :meeting_id="meeting_id" :show_support="show_support"
						v-if="bottom_word_show && !home_bg_img">
					</bottom>
				</div>
			</div>

		</div>
	</div>
</template>
<script>
// import Register from "../../components/Users/Register.vue"
import { MeetingButtons, MeetingsCarousel, MeetingsDetails, companyImages } from '../../../config/interface.js'
import { ImagePreview, Col, Row } from 'vant'    //预览图片   使用的函数调用
import TopImage from '../components/TopImage.vue'
import Bottom from '../Meeting/Bottom.vue'


export default {
	components: {
		TopImage,
		Bottom,
		Col, Row
	},
	data() {
		return {
			meetingButton: [],    //会议按钮
			button_rows: 3,     //menu一行按钮数
			swiperImg: [],
			images: [],
			show_button_text: 0,
			meeting_name: '',
			views: 0,
			show_views: 0,
			bottom_word_show: 0,
			show_support: 1,
			meeting_bg_513: require('../../../assets/images/Meeting/meeting_bg_513.png'),
			name: '',
			search_writer_show: false,
			home_bg_color: '',//背景色
			home_bg_img: '',//背景图,
			meeting_id: '602'

		}
	},
	beforeRouteEnter(to, from, next) {
		//  修复iOS版微信HTML5 History兼容性问题
		if (to.path !== location.pathname) {

			location.assign(to.fullPath)
		} else {
			next()
		}
	},
	mounted() {

		// console.log(this.$route)
		// this.meeting_id=this.$route.query.meeting_id;
		this.getMeetingDetails();
		this.getMeetingButtons(this.meeting_id);
		this.getMeetingCarousel();
		this.getImages();

	},
	// computed: {
	// 	meeting_id() {
	// 		return this.$route.query.meeting_id ? this.$route.query.meeting_id : (this.$route.query.id ? this.$route.query.id : this.$route.query.MT_id);
	// 	}
	// },
	methods: {
		getImages() {
			const url = companyImages;
			let params = {
				meeting_id: this.meeting_id,
			}
			const method = "POST";
			fetch(url, params, method)
				.then((res) => {
					if (res.code == 0) {
						this.images = res.data;
					}
				})
		},
		//跳转链接
		skipLink(item) {
			console.log(item)
			if (item.url.match(/\.(jpeg|jpg|gif|png)$/)) {
				ImagePreview({
					images: [item.url],
					closeable: true,
					showIndex: false
				});
			}
			//  else if(item.button_type==9){
			// 	window.location.href='/vascularNews/meeting/files?meeting_id='+this.meeting_id+'&button_id='+item.id;
			// }
			else {
				window.localStorage.removeItem('callback_url');
				window.localStorage.setItem('callback_url', item.url);
				window.location.href = item.url;
				if (item.url.indexOf('vascularnews/meeting/schedule') > -1 && window.localStorage.getItem('schedule_date')) {
					window.localStorage.removeItem('schedule_date');

				}

			}

		},
		searchExpert(val) {
			console.log('keywords', val)
			this.$router.push('/vascularNews/expert/search?meeting_id=' + this.meeting_id + '&keywords=' + val)
		},
		//会议轮播
		getMeetingCarousel() {
			const url = MeetingsCarousel;
			let params = {
				meeting_id: this.meeting_id
			}
			const method = 'POST';
			fetch(url, params, method)
				.then((res) => {
					if (res.code == 0) {
						let data = res.data;
						this.swiperImg = data;
					}
				})
		},
		//点击轮播图跳转
		clickSwiperImg(item) {
			window.location.href = item.link;
		},
		//会议按钮
		getMeetingButtons(id) {
			const url = MeetingButtons;
			const method = 'POST';
			let params = {
				meeting_id: id
			};
			fetch(url, params, method)
				.then((res) => {
					if (res.code == 0) {
						let data = res.data;
						for (let i in data) {
							var obj = {
								url: data[i].url,
								name: data[i].name,
								icon: data[i].icon,
								button_type: data[i].button_type,
								id: data[i].id,
								icon_type: data[i].icon_type

							}
							this.meetingButton.push(obj);
						}
					}
				})
		},
		//会议详情
		getMeetingDetails(id) {
			const url = MeetingsDetails;
			const method = 'POST';
			let params = {
				meeting_id: this.meeting_id
			}
			fetch(url, params, method)
				.then((res) => {
					if (res.code == 0) {

						let data = res.data;
						document.title = data.name;

						this.home_bg_img = data.home_bg_img;
						this.home_bg_color = data.home_bg_color;
						this.meeting_name = data.name;
						this.button_rows = data.button_rows;
						this.show_button_text = data.show_button_text;
						this.show_views = data.show_views
						this.views = data.views
						this.bottom_word_show = data.bottom_word_show;
						this.show_support = data.platform_support_show;
						this.search_writer_show = data.search_writer_show


						//微信浏览器  请求jsdk
						if (common.is_weixin()) {
							common.wxShare(data.name, data.title, data.shareimg);
						}
					}
				})
		},
	}
}
</script>
<style lang="scss" scoped>
.meeting-details_602 {
	overflow: hidden;
	min-height: 100vh;
	background-repeat: no-repeat;
	background-size: 100% 100%;
	background-position: top center;
	height: 100%;

	.bottom-number {
		margin-bottom: 0;
	}

	.content {
		min-height: calc(100vh - 80px);
	}

	.banner-show {
		width: 100%;

		.cover {
			width: 100%;
			position: relative;


			img {
				width: 100%;
			}
		}
	}

	.bg {
		background: #f9f8fb;
	}

	.relation602 {
		// overflow: auto;
		padding: 0.5rem;
		@include flex(row);
		align-items: center;
		flex-wrap: wrap;
		width: 100%;

		.van-row {
			width: 100%;
			line-height: 0;

		}

		.van-col {
			line-height: 0;
		}

		div {
			text-align: center;
		}

		a {
			display: inline-block;
			text-align: center;
			line-height: 0;
			padding: 0.16rem;
			// margin-bottom: 16px;
		}

		img {
			width: 100%;
			height: 100%;

		}
	}


	.one-column {
		flex-direction: column;
		align-items: flex-start;
	}

}

.views {
	text-align: right;
	color: #ffffff;
	background-image: linear-gradient(180deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5));
	line-height: 30px;
	height: 30px;
	position: absolute;
	width: 100%;
	bottom: 0;
	padding: 0 10px;
}

.adver_img {
	width: 100%;

	img {
		width: 100%;
	}

}

.sp_btn {
	position: absolute !important;
	bottom: 30px !important;
	width: 80px !important;
}

.van-search__content {
	background-color: #ffffff;
}

.van-search {
	background-color: transparent;
}


@media screen and (min-width: 550px) {
	.relation602 a {
		padding: 0.27rem !important;
	}
}

div::webkit-scrollbar {
	display: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/VascularSystem/Meeting602/index.vue